var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentFile,{tag:"component",attrs:{"carrier":_vm.carrier}})
}
var staticRenderFns = []

export { render, staticRenderFns }